import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {LeadModalStep} from "../../application/types/LeadModalStep";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {CreditEstimatedValue} from "../../credit_calculator/components/CreditEstimatedValue";
import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {AdditionalFormFieldType} from "../../lead/types/AdditionalFormFieldType";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";
import {PropertyHighlightPrice} from "./PropertyHighlightPrice";

interface IProps {
    property: IPropertyDetail;
    initialStep?: LeadModalStep;
}

export const PropertyDetailHeaderPriceNegotiation = (props: IProps) => {
    const {initialStep, property} = props;

    const currency = property.offer.currency;

    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    if (!property.price || !shouldShowPrice) {
        return null;
    }

    const isPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;

    const gtmData = {
        clickText: InquiryButtonTypeName.NEGOTIATE,
        source: GTMEventApplicationSourceSection.HEADER_NEGOTIATE,
        vendorName: property.offer.vendor.name ?? property.offer.vendor.id.toString(),
        offerName: property.offer.name ?? property.offer.id.toString()
    };

    return (
        <div className={priceInfoWrapper}>
            <div className={priceInfo}>
                <PropertyHighlightPrice property={property} />
                <CreditEstimatedValue price={property.price} currency={currency} />
            </div>
            {property.for_sale && isPublished && (
                <ApplicationModalButton
                    initialStep={initialStep}
                    render={({openModal}) => (
                        <Button variant="filled_primary" size="x-small" type="button" onClick={() => openModal(gtmData)} className={buttonStyle}>
                            Negocjuj cenę
                        </Button>
                    )}
                    vendorId={property.offer.vendor.id}
                    offerId={property.offer.id}
                    propertyId={property.id}
                    source={ApplicationSource.NegotiatePrice}
                    sourceSection={ApplicationSourceSection.MODAL}
                    useAdditionalFormField={AdditionalFormFieldType.NEGOTIATION}
                    currency={property?.offer.currency}
                />
            )}
        </div>
    );
};

const priceInfoWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: 0.5,

    xs: {
        flexDirection: "row",
        gap: 2
    }
});

const priceInfo = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const buttonStyle = css({
    fontSize: "14px",
    minWidth: "-webkit-fill-available",

    xs: {
        minWidth: "fit-content"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {LeadModalStep} from "../../application/types/LeadModalStep";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {CreditEstimatedValue} from "../../credit_calculator/components/CreditEstimatedValue";
import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {AdditionalFormFieldType} from "../../lead/types/AdditionalFormFieldType";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";
import {PropertyHighlightPrice} from "./PropertyHighlightPrice";

interface IProps {
    property: IPropertyDetail;
    initialStep?: LeadModalStep;
}

export const PropertyDetailHeaderPriceNegotiation = (props: IProps) => {
    const {initialStep, property} = props;

    const currency = property.offer.currency;

    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    if (!property.price || !shouldShowPrice) {
        return null;
    }

    const isPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;

    const gtmData = {
        clickText: InquiryButtonTypeName.NEGOTIATE,
        source: GTMEventApplicationSourceSection.HEADER_NEGOTIATE,
        vendorName: property.offer.vendor.name ?? property.offer.vendor.id.toString(),
        offerName: property.offer.name ?? property.offer.id.toString()
    };

    return (
        <div className={priceInfoWrapper}>
            <div className={priceInfo}>
                <PropertyHighlightPrice property={property} />
                <CreditEstimatedValue price={property.price} currency={currency} />
            </div>
            {property.for_sale && isPublished && (
                <ApplicationModalButton
                    initialStep={initialStep}
                    render={({openModal}) => (
                        <Button variant="filled_primary" size="x-small" type="button" onClick={() => openModal(gtmData)} className={buttonStyle}>
                            Negocjuj cenę
                        </Button>
                    )}
                    vendorId={property.offer.vendor.id}
                    offerId={property.offer.id}
                    propertyId={property.id}
                    source={ApplicationSource.NegotiatePrice}
                    sourceSection={ApplicationSourceSection.MODAL}
                    useAdditionalFormField={AdditionalFormFieldType.NEGOTIATION}
                    currency={property?.offer.currency}
                />
            )}
        </div>
    );
};

const priceInfoWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: 0.5,

    xs: {
        flexDirection: "row",
        gap: 2
    }
});

const priceInfo = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const buttonStyle = css({
    fontSize: "14px",
    minWidth: "-webkit-fill-available",

    xs: {
        minWidth: "fit-content"
    }
});
